import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Inject Facebook domain verification meta tag
const meta = document.createElement('meta');
meta.name = 'facebook-domain-verification';
meta.content = 'f80uucent0vtsdoj6zh782om6dzjsz';
document.getElementsByTagName('head')[0].appendChild(meta);
render(<App data-id="element-347" />, document.getElementById('root'));